import { useMemo, useState } from "react";
import styled from "styled-components";
import { Drawer, Layout, CircularLoader } from "@introist/react-foundation/v2";

import { useIntegrationsApi } from "services/api/IntegrationsApi";

import { IntegrationEditor } from "../IntegrationEditor";
import { IntegrationsGrid } from "../../components";
import { Integration } from "../..";

const StyledDrawer = styled(Drawer)`
  padding: var(--spacing-xxLarge) var(--spacing-xLarge);
`;

export const IntegrationsContainer = () => {
  const [activeIntegration, setActiveIntegration] = useState<Integration>();
  const [open, setOpen] = useState<boolean>(false);
  const integrationApi = useIntegrationsApi();
  const { data, isLoading: integrationsLoading } = integrationApi.list().query;

  const ats = useMemo(() => {
    return (data ?? []).filter(i => (i.categories ?? []).includes("ATS"));
  }, [data]);
  const other = useMemo(() => {
    return (data ?? []).filter(i => (i.categories ?? []).includes("other"));
  }, [data]);

  if (integrationsLoading) {
    return <CircularLoader fillParent style={{ flex: 1 }} />;
  }

  return (
    <Layout.Group vertical gap="xxLarge">
      <IntegrationsGrid
        title="ATS"
        description='Automatically start workflows when the candidate status is "Hired"'
        integrations={ats}
        onIntegrationClick={integration => {
          setActiveIntegration(integration);
          setOpen(true);
        }}
      />

      <IntegrationsGrid
        title="Productivity"
        description="Boost your productivity by automating tasks like ticketing and account setup"
        integrations={other}
        onIntegrationClick={integration => {
          setActiveIntegration(integration);
          setOpen(true);
        }}
      />

      <StyledDrawer open={open} onClose={() => setOpen(false)} width="540px">
        {activeIntegration && (
          <IntegrationEditor integrationId={activeIntegration?.id} onClose={() => setOpen(false)} />
        )}
      </StyledDrawer>
    </Layout.Group>
  );
};
